'use strict';

angular.module('app.influencerChannelList')

.directive('influencerChannelListDirective', function () {
        return {
            controller: 'influencerChannelListCtrl',
            templateUrl: 'app/sideBarMenu/influencerChannelList/influencerChannelList.html?app_v=deployDate',
            scope: {}
        };
})